var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 418,
    viewBox: "0 0 351 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 5,
    x2: 346,
    y2: 5,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 24,
    x2: 346,
    y2: 24,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 43,
    x2: 346,
    y2: 43,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 62,
    x2: 346,
    y2: 62,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 81,
    x2: 346,
    y2: 81,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 346,
    y2: 100,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 119,
    x2: 346,
    y2: 119,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 138,
    x2: 346,
    y2: 138,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 157,
    x2: 346,
    y2: 157,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 176,
    x2: 346,
    y2: 176,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 195,
    x2: 346,
    y2: 195,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 214,
    x2: 346,
    y2: 214,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 233,
    x2: 346,
    y2: 233,
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.01 18"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 311,
    cy: 62,
    r: 9.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 293,
    cy: 195,
    r: 9.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 190,
    cy: 24,
    r: 9.5,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 311,
    cy: 62,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 293,
    cy: 195,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 190,
    cy: 24,
    r: 2,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroBg);
export default __webpack_public_path__ + "static/media/intro-bg.d68fe5aa215afe8ccb43d414e1826b1a.svg";
export { ForwardRef as ReactComponent };